var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735894458956,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4644,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M631.16 112H269.44A71.54 71.54 0 0 0 198 183.64V708h584V263.24z",
    fill: "#DEE2E6",
    "p-id": 4645
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M781.52 263.36h-115.08a35.8 35.8 0 0 1-35.74-35.84V112z",
    fill: "#868E96",
    "p-id": 4646
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.08 298.56m18.34 0l247.18 0q18.34 0 18.34 18.34l0 0.04q0 18.34-18.34 18.34l-247.18 0q-18.34 0-18.34-18.34l0-0.04q0-18.34 18.34-18.34Z",
    fill: "#ADB5BD",
    "p-id": 4647
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.08 426.56m18.34 0l339.18 0q18.34 0 18.34 18.34l0 0.04q0 18.34-18.34 18.34l-339.18 0q-18.34 0-18.34-18.34l0-0.04q0-18.34 18.34-18.34Z",
    fill: "#ADB5BD",
    "p-id": 4648
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M695.06 882.52a37.86 37.86 0 0 1-53.26 3.64l-138.86-120.5 49.6-56.7 138.86 120.5a37.48 37.48 0 0 1 3.66 53.06z",
    fill: "#F9BF87",
    "p-id": 4649
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M638.2 918.38a33.5 33.5 0 0 1-47.12 3.22l-122.86-106.6L512 764.84l122.88 106.62a33.18 33.18 0 0 1 3.32 46.92z",
    fill: "#F9BF87",
    "p-id": 4650
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M578.92 942.42a28.12 28.12 0 0 1-39.56 2.72l-103.18-89.54 36.84-42.12 103.18 89.52a27.86 27.86 0 0 1 2.72 39.42z",
    fill: "#F9BF87",
    "p-id": 4651
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M520.78 940.28a28.12 28.12 0 0 1-39.56 2.72L378 853.46l36.84-42.12L518 900.88a27.86 27.86 0 0 1 2.78 39.4z",
    fill: "#F9BF87",
    "p-id": 4652
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M720.76 819L698 835.16l-128.92 92-81.26 8.84a30.86 30.86 0 0 1-23.3-7.12l-185.88-157.52 9.52-164.82 162.22 2c4.68-0.24 9.36-0.42 14-0.48a430 430 0 0 1 98.62 9.58l0.46 0.1 86.16 18.7z",
    fill: "#F9BF87",
    "p-id": 4653
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M759.88 795.3L698 835.16l-1.44-1.04s-126.44-126-137.78-137.24-51.12 8.32-87.58 29.12c-27.52 15.7-50.12 13.74-61.02-12-19.38-45.66 79.48-103.38 82-105.62 33.12-0.62 38.42 2.22 70.82 9.2l0.46 0.1 86.16 18.7z",
    fill: "#E09E68",
    "p-id": 4654
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M830.62 788.12L775.26 820a17.22 17.22 0 0 1-23.48-6.26l-110.54-190.68a17.08 17.08 0 0 1 6.3-23.38l55.34-31.82a17.22 17.22 0 0 1 23.5 6.14l110.54 190.68a17.08 17.08 0 0 1-6.3 23.44z",
    fill: "#B197FC",
    "p-id": 4655
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M901.24 779.72L832 819.56a21.56 21.56 0 0 1-29.4-7.84l-138.38-238.68a21.38 21.38 0 0 1 7.78-29.26L741.36 504a21.56 21.56 0 0 1 29.4 7.84l138.34 238.66a21.38 21.38 0 0 1-7.86 29.22z",
    fill: "#9775FA",
    "p-id": 4656
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M819.54 751.08a18.92 18.84 0 1 0 37.84 0 18.92 18.84 0 1 0-37.84 0Z",
    fill: "#FFFFFF",
    "p-id": 4657
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 547.78l60.76 19.74a17.1 17.1 0 0 1 11.02 21.58l-68.58 209.32a17.2 17.2 0 0 1-21.68 10.96l-60.76-19.74a17.1 17.1 0 0 1-11-21.64l68.58-209.3a17.2 17.2 0 0 1 21.66-10.92z",
    fill: "#F783AC",
    "p-id": 4658
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226 501.06l76 24.72a21.42 21.42 0 0 1 13.78 27.02L230 814.78a21.54 21.54 0 0 1-27.14 13.72l-76-24.72a21.42 21.42 0 0 1-13.78-27.02l85.84-262a21.54 21.54 0 0 1 27.08-13.7z",
    fill: "#F06595",
    "p-id": 4659
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.126196 779.204601a18.92 18.84 3.06 1 0 2.011423-37.626275 18.92 18.84 3.06 1 0-2.011423 37.626275Z",
    fill: "#FFFFFF",
    "p-id": 4660
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M420.18 700.84a23.88 23.78 0 1 0 47.76 0 23.88 23.78 0 1 0-47.76 0Z",
    fill: "#EAAE73",
    "p-id": 4661
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArap);
export default __webpack_public_path__ + "static/media/arap.43c701dbb6e2b95366b50752f5f70afc.svg";
export { ForwardRef as ReactComponent };